// extracted by mini-css-extract-plugin
module.exports = {"center":"Message_center__kwcei"};